// Persona AI-interviewer call links. Not sensitive, so they're hardcoded rather
// than routed through config. One per flow/script configured on Persona's side.
const PERSONA_INTERVIEW_LINK = 'https://call.insightscompany.io/176bfdb3-714c-4cca-a9b2-9c0d2285497a/72b244b8-c152-421a-b0ed-513fb6a32262';
const PERSONA_CALL_FLOW_LINK = 'https://call.insightscompany.io/4ea1e11c-9f58-44d3-a904-3f41c373352e/d8a8ea26-e23c-40dd-a78d-347fbc7878f5';

// Hardcoded "in-demand" role+company combos, shared between the follow-up email
// eligibility check and the /contribute funnel's Persona skip-review CTA.
// For all roles in a company, set {role: null, company: 'anthropic'}
const IN_DEMAND_ROLES_COMPANIES = [
  // roles
  {role: 'forward-deployed-engineer', company: null},

  // AI labs
  {role: null, company: 'anthropic'},
  {role: null, company: 'openai'},
  {role: null, company: 'google-deepmind'},
  {role: null, company: 'x-ai'},
  {role: null, company: 'cursor'},
  {role: null, company: 'perplexity-ai'},
  {role: null, company: 'nvidia'},
  {role: null, company: 'eleven-labs'},
  {role: null, company: 'scale-ai'},
  {role: null, company: 'sierra-ai'},
  {role: null, company: 'mistral-ai'},
  {role: null, company: 'cognition-ai'},
  {role: null, company: 'anduril'},
  {role: null, company: 'lovable'},
  {role: null, company: 'replit'},
  {role: null, company: 'harvey-ai'},
  {role: null, company: 'github'},

  // FAANG
  {role: null, company: 'google'},
  {role: null, company: 'microsoft'},
  {role: null, company: 'amazon'},
  {role: null, company: 'apple'},
  {role: null, company: 'meta-facebook'},
  {role: null, company: 'netflix'},
  {role: null, company: 'stripe'},
  {role: null, company: 'salesforce'},
  {role: null, company: 'uber'},
  {role: null, company: 'doordash'},
  {role: null, company: 'pinterest'},
  {role: null, company: 'linkedin'},
  {role: null, company: 'reddit'},
  {role: null, company: 'roblox'},
  {role: null, company: 'spotify'},
  {role: null, company: 'airbnb'},
  {role: null, company: 'tiktok'},
  {role: null, company: 'snap'},
  {role: null, company: 'figma'},
  {role: null, company: 'notion'},
  {role: null, company: 'databricks'},
  {role: null, company: 'jane-street'},
];

const isInDemand = (role, company) => IN_DEMAND_ROLES_COMPANIES.some(
  (combo) => (combo.role === null || combo.role === role)
    && (combo.company === null || combo.company === company),
);

const PERSONA_ELIGIBLE_COUNTRIES = ['US', 'GB'];

// 'waiting' already means "finished final round" per its label in RESULTS (lib/utils).
const PERSONA_ELIGIBLE_RESULTS = ['waiting', 'accepted', 'declined'];

const isEligibleForContributePersonaCTA = ({
  role, company, location, result,
}) => isInDemand(role, company)
  && PERSONA_ELIGIBLE_COUNTRIES.includes(location)
  && PERSONA_ELIGIBLE_RESULTS.includes(result);

module.exports = {
  PERSONA_INTERVIEW_LINK,
  PERSONA_CALL_FLOW_LINK,
  IN_DEMAND_ROLES_COMPANIES,
  isInDemand,
  PERSONA_ELIGIBLE_COUNTRIES,
  PERSONA_ELIGIBLE_RESULTS,
  isEligibleForContributePersonaCTA,
};
